import React, { Component } from 'react'
import { Pagination } from 'react-admin'
import { TextField, NumberField, BooleanField, ReferenceField, DateField } from '../Fields'
import _ from 'lodash'

import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import ClearIcon from '@material-ui/icons/Clear'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import SaveIcon from '@material-ui/icons/Save'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import { schemaAsFieldArray } from '../../utils/schemas'


const styles = theme => ({
  root : {
      marginTop : 6,
      color: '#676767',
  },
  select : {
      border: '1px solid #C7C7C7',
      padding : 8,
      paddingLeft: 5,
      paddingBottom: 9,
      color: '#676767',
      backgroundColor : '#fff',
  },
  disabled : {
      color : '#9E9E9E',
      backgroundColor : '#FCFCFC'
  },
  textField : {
      marginTop: 0,
  },
  input : {
      border: '1px solid #C7C7C7',
      paddingLeft: 5,
      color: '#676767',
      marginTop: 6,
      backgroundColor : '#fff',
  },
  label : {
      color : '#3CA7AC',
      fontSize : 18,
      fontWeight: 600,
      textTransform: 'capitalize',
  },
  item : {
      display: 'flex',
      alignItems: 'center',
  },
  icon : {
      backgroundSize: 'cover',
      width: 20,
      height: 20,
      display: 'inline-block',
      marginRight: "10px",
  },
  iconAprobado : { backgroundImage: 'url("/images/parametro_aprobado_small.png")' },
  iconEnUso : { backgroundImage: 'url("/images/parametro_en_uso_small.png")' },
  iconRechazado : { backgroundImage: 'url("/images/parametro_rechazado_small.png")' },
})


class CertificationTable extends Component {

  renderCertificationSelect(instalation, field, value) {
    const { classes } = this.props
    const selectClasses = {
      root: classes.root,
      select: classes.select,
      disabled: classes.disabled
    }
    return (
      <FormControl fullWidth>
          <Select
              classes={selectClasses}
              inputProps={{
                  name: `${instalation.id}.datasheet.ESTADO_CERTIFICACION.${field.name}`,
                  id: `${instalation.id}.datasheet.ESTADO_CERTIFICACION.${field.name}`,
              }}
              displayEmpty={false}
              onChange={this.props.onStatusChange()}
              value={value}
          >
            <MenuItem value={"No Revisado"}>{"No Revisado"}</MenuItem>
            <MenuItem value={"Validado"}>
                <div className={classes.item}>
                    <i className={classnames(classes.icon, classes.iconAprobado)}></i>
                    <span>{"Validado"}</span>
                </div>
            </MenuItem>
            <MenuItem value={"En Uso"}>
                <div className={classes.item}>
                    <i className={classnames(classes.icon, classes.iconEnUso)}></i>
                    <span>{"En Uso"}</span>
                </div>
            </MenuItem>
            <MenuItem value={"Rechazado"}>
                <div className={classes.item}>
                    <i className={classnames(classes.icon, classes.iconRechazado)}></i>
                    <span>{"Rechazado"}</span>
                </div>
            </MenuItem>
          </Select>
      </FormControl>
    )
  }

  renderValue(field, datasheet){
    switch (field.type) {
        case "string":
            return <TextField source={field.name} record={datasheet} />
        case "number":
            return <NumberField source={field.name} record={datasheet} />
        case "boolean":
            return <BooleanField source={field.name} record={datasheet} />
        case "reference":
            return (
              <Table>
                  <TableBody>
                      {_.map(field.fields, ref_field =>
                        this.renderValue(ref_field, datasheet[field.name])
                      )}
                  </TableBody>
              </Table>
            )
        case "technicalData":
            return (
              <ReferenceField
                  source={field.name}
                  record={datasheet}
                  allowEmpty={true}
                  reference={'datos-tecnicos'}
                  basePath={"/datos-tecnicos"}>
                  <TextField source="name"/>
              </ReferenceField>
            )
        case "date":
            return <DateField source={field.name} record={datasheet} />
        case "document":
            return (
              <ReferenceField
                  source={field.name}
                  record={datasheet}
                  reference={'documentos'}
                  basePath={"/documentos"}>
                  <TextField source="name"/>
              </ReferenceField>
            )
        default:
            return null
    }
  }

  renderInstalations() {
    const {
      ids,
      selectedIds,
      instalations,
      datoTecnico,
      schema,
      resource
    } = this.props

    return _.map(ids, id => {
      const instalation = _.get(instalations, `${id}`, false)
      if (!instalation) { return null }

      return _.map(schemaAsFieldArray(schema), field => {
        if (!datoTecnico || (!!datoTecnico && field.name === datoTecnico)) {
          const value = _.get(instalation.datasheet, `${field.name}`, false)
          const certificationStatus = _.get(
            instalation.datasheet,
            `ESTADO_CERTIFICACION.${field.name}`,
            "No Revisado"
          )

          return (
            <TableRow key={`${instalation.id}-${field.name}`}>
              <TableCell padding={"none"}>
                <Checkbox
                  className="select-all"
                  color="primary"
                  checked={selectedIds.has(`${id}.${field.name}`)}
                  onChange={this.props.onSelect(`${id}.${field.name}`)}
                 />
              </TableCell>
              <TableCell padding={"none"}>{instalation.id}</TableCell>
              <TableCell>
                <ReferenceField
                    source={"id"}
                    record={instalation}
                    reference={resource}
                    basePath={resource}>
                    <TextField source="name"/>
                </ReferenceField>
              </TableCell>
              <TableCell>{field.title}</TableCell>
              <TableCell>{value ? this.renderValue(field, instalation.datasheet) : "---"}</TableCell>
              <TableCell>
                {this.renderCertificationSelect(instalation, field, certificationStatus)}
              </TableCell>
            </TableRow>
          )
        } else {
          return null
        }
      })
    })
  }

  renderActions() {
    const { classes, selectedIds } = this.props

    const changeStatus = selectedIds.size === 0
      ? this.props.changeAllStatus
      : this.props.changeSelectedStatus

    const statusButtons = (
      <TableRow>
        <TableCell colSpan={6}>
          <Grid container spacing={16}>
            <Grid item xs={12}>
              {selectedIds.size === 0
                ? "Marcar todos:"
                : "Marcar seleccionados:"
              }
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Button color={"primary"} fullWidth onClick={() => changeStatus("No Revisado")}>
                No Revisado
              </Button>
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Button color={"primary"} fullWidth onClick={() => changeStatus("Rechazado")}>
                <i className={classnames(classes.icon, classes.iconRechazado)}></i>
                Rechazado
              </Button>
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Button color={"primary"} fullWidth onClick={() => changeStatus("En Uso")}>
                <i className={classnames(classes.icon, classes.iconEnUso)}></i>
                En Uso
              </Button>
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Button color={"primary"} fullWidth onClick={() => changeStatus("Validado")}>
                <i className={classnames(classes.icon, classes.iconAprobado)}></i>
                Validado
              </Button>
            </Grid>
          </Grid>
        </TableCell>
      </TableRow>
    )

    const discardOrSave = (
      <TableRow>
        <TableCell colSpan={4}></TableCell>
        <TableCell colSpan={2}>
          <Grid container spacing={16}>
            <Grid item xs={12} md={2} lg={4}>
              <Button color={"primary"} fullWidth onClick={this.props.onClear}>
                <ClearIcon className={classes.icon} />
                Descartar cambios
              </Button>
            </Grid>
            <Grid item xs={12} md={2} lg={4}>
              <Button color={"primary"} fullWidth onClick={this.props.onSave}>
                <SaveIcon className={classes.icon} />
                Guardar cambios
              </Button>
            </Grid>
          </Grid>
        </TableCell>
      </TableRow>
    )

    return (
      <React.Fragment>
        {statusButtons}
        {discardOrSave}
      </React.Fragment>
    )
  }

  render() {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding={"none"}></TableCell>
            <TableCell padding={"none"}>ID</TableCell>
            <TableCell>Nombre Instalación</TableCell>
            <TableCell>Dato Técnico</TableCell>
            <TableCell>Valor</TableCell>
            <TableCell>Estado Certificación</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!!this.props.instalations && this.renderInstalations()}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell colSpan={6}>
              <Pagination
                page={this.props.page}
                perPage={this.props.perPage}
                isLoading={this.props.loading}
                total={this.props.total}
                setPage={this.props.onPageChange}
                setPerPage={this.props.onPerPageChange}
                labelRowsPerPage={"Instalaciones por página:"}
                labelDisplayedRows={({ from, to, count }) => `Mostrando resultados ${from} a ${to} de ${count}`}
              />
            </TableCell>
          </TableRow>
          {!!this.props.instalations && this.renderActions()}
        </TableFooter>
      </Table>
    )
  }
}

export default withStyles(styles)(CertificationTable)
